// extracted by mini-css-extract-plugin
export default {"root":"Radio_root__pmBSj","label":"Radio_label__jkQpE","control":"Radio_control__TYHvb"};